import React from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import PageTitle from "../../layouts/PageTitle";
import { IMAGES } from "../../constant/theme";
import { useGetStaffByIdQuery } from "../../../store/appApi";
import { selectUserRole } from "../../../store/authSlice";
import AttendanceCalendarCard from "../../components/AttendanceCalendarCard";

function StaffProfile() {
  const { id } = useParams();
  const isSuperAdmin = useSelector(selectUserRole) === "super-admin";
  const { data: staffResponse, isLoading, isError } = useGetStaffByIdQuery(id, { skip: !id });
  const user = staffResponse?.user || null;

  if (isLoading) {
    return (
      <div className="row">
        <div className="col-12"><p>Loading profile...</p></div>
      </div>
    );
  }

  if (isError || !user) {
    return (
      <div className="row">
        <div className="col-12"><p className="text-danger">Failed to load staff profile.</p></div>
      </div>
    );
  }

  const joiningDate = user.joiningDate
    ? new Date(user.joiningDate).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })
    : "—";

  const createdAt = user.created
    ? new Date(user.created).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })
    : "—";

  const detailblog = [
    { title: "Gender", subtitle: user.gender || "—" },
    { title: "Role", subtitle: user.role || "—" },
    { title: "Adhaar Card", subtitle: user.adhaarCard || "—" },
    { title: "City", subtitle: user.city || "—" },
  ];

  const personalDetail = [
    { title: "Full Name", subtitle: user.name || "—" },
    { title: "Phone", subtitle: user.phone || "—" },
    { title: "Email", subtitle: user.email || "—" },
    { title: "City", subtitle: user.city || "—" },
    { title: "Joining Date", subtitle: joiningDate },
    { title: "Added On", subtitle: createdAt },
    {
      title: "Status",
      subtitle: user.status ? "Active" : "Disabled",
      badge: user.status ? "success" : "danger",
    },
    {
      title: "Attendance",
      subtitle: user.attendanceEnabled !== false ? "Enabled" : "Disabled",
      badge: user.attendanceEnabled !== false ? "success" : "warning",
    },
  ];

  return (
    <div className="row">
      <div className="col-xl-3 col-xxl-4 col-lg-4">
        <div className="row">
          {/* ── Profile photo card ── */}
          <div className="col-lg-12">
            <div className="card overflow-hidden">
              <div
                className="text-center p-3 overlay-box"
                style={{ backgroundImage: `url(${IMAGES.BigImg1})` }}
              >
                <div className="profile-photo">
                  <img
                    src={IMAGES.Profile}
                    width="100"
                    className="img-fluid rounded-circle"
                    alt=""
                  />
                </div>
                <h3 className="mt-3 mb-1 text-white" style={{ textTransform: "capitalize" }}>
                  {user.name}
                </h3>
                <p className="text-white mb-0" style={{ textTransform: "capitalize" }}>
                  {user.role}
                </p>
              </div>
              {isSuperAdmin && (
                <div className="card-footer text-center border-0 mt-0">
                  <Link to={`/edit-staff/${id}`} className="btn btn-primary px-4">
                    Edit Profile
                  </Link>
                </div>
              )}
            </div>
          </div>

          {/* ── About Me ── */}
          <div className="col-lg-12">
            <div className="card overflow-hidden">
              <div className="card-header">
                <h2 className="card-title">About</h2>
              </div>
              <div className="card-body pb-0">
                <ul className="list-group list-group-flush">
                  {detailblog.map((item, ind) => (
                    <li
                      className="list-group-item d-flex px-0 justify-content-between"
                      key={ind}
                    >
                      <strong>{item.title}</strong>
                      <span className="mb-0" style={{ textTransform: "capitalize" }}>
                        {item.subtitle}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* ── Address ── */}
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header d-block">
                <h4 className="card-title">Address</h4>
              </div>
              <div className="card-body">
                <p className="mb-0">{user.address || "—"}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Personal Details + Attendance ── */}
      <div className="col-xl-9 col-xxl-8 col-lg-8">
        <div className="card mb-4">
          <div className="card-header">
            <h4 className="card-title">Personal Details</h4>
          </div>
          <div className="card-body">
            <ul className="list-group list-group-flush">
              {personalDetail.map((item, ind) => (
                <li
                  className="list-group-item d-flex px-0 justify-content-between align-items-center"
                  key={ind}
                >
                  <strong>{item.title}</strong>
                  {item.badge ? (
                    <span className={`badge badge-${item.badge}`}>{item.subtitle}</span>
                  ) : (
                    <span className="mb-0">{item.subtitle}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {user.attendanceEnabled !== false && (
          <AttendanceCalendarCard userId={id} title={`Attendance — ${user.name}`} />
        )}
      </div>
    </div>
  );
}

const ProfileStaff = () => {
  return (
    <>
      <PageTitle activeMenu="Staff Profile" motherMenu={"Staff"} />
      <StaffProfile />
    </>
  );
};

export { StaffProfile };
export default ProfileStaff;
